export default __webpack_public_path__ + "static/media/t8.min.31b6a505.png";